import { FanToCreate } from '@/fairplayer/domain/fan/FanToCreate';

export interface BackendFanToCreate {
  pictureUrl?: string;
}

export const fromFanToCreate = (fan: FanToCreate): BackendFanToCreate => ({
  pictureUrl: fan.pictureUrl.orElseUndefined(),
});
